import { BsChatDotsFill, BsWhatsapp } from 'react-icons/bs'
import { FaFacebookMessenger, FaInstagram } from 'react-icons/fa'
import type { IconType } from 'react-icons'

import type { ChatChannel } from '@/lib/api/common/interfaces/message.interface'

/** Ícone, cores e nome de cada canal de conversa. Canal ausente = WhatsApp (o legado). */
export const CHAT_CHANNEL_META: Record<ChatChannel, { label: string; icon: IconType; text: string; bg: string }> = {
    WHATSAPP: { label: 'WhatsApp', icon: BsWhatsapp, text: 'text-green-500', bg: 'bg-green-500' },
    INSTAGRAM: { label: 'Instagram', icon: FaInstagram, text: 'text-pink-500', bg: 'bg-pink-500' },
    MESSENGER: { label: 'Messenger', icon: FaFacebookMessenger, text: 'text-blue-500', bg: 'bg-blue-500' },
    // Canal do próprio sistema (aplicativo, simulador de conversas): "Dex" na interface.
    DEX_TALK: { label: 'Dex', icon: BsChatDotsFill, text: 'text-primary', bg: 'bg-primary' },
}

export const chatChannelMeta = (channel?: ChatChannel | string | null) =>
    CHAT_CHANNEL_META[(channel as ChatChannel) in CHAT_CHANNEL_META ? (channel as ChatChannel) : 'WHATSAPP']

interface ChatChannelIconProps {
    channel?: ChatChannel | string | null
    size?: number
    /** Sem cor própria: herda a do botão (ex.: verde de conversa aberta). */
    colored?: boolean
    className?: string
}

/** Ícone do canal da conversa, com o nome no title. */
export function ChatChannelIcon({ channel, size = 14, colored = true, className = '' }: ChatChannelIconProps) {
    const meta = chatChannelMeta(channel)
    const Icon = meta.icon
    return (
        <span className={`inline-flex ${colored ? meta.text : ''} ${className}`} title={meta.label}>
            <Icon size={size} />
        </span>
    )
}

/** Selo redondo no canto do avatar das listas de atendimento. */
export function ChatChannelAvatarBadge({
    channel,
    sizeClass = 'w-3.5 h-3.5',
    iconClass = 'text-[7px]',
}: {
    channel?: ChatChannel | string | null
    sizeClass?: string
    iconClass?: string
}) {
    const meta = chatChannelMeta(channel)
    const Icon = meta.icon
    return (
        <div
            className={`absolute -bottom-0.5 -right-0.5 ${sizeClass} rounded-full ${meta.bg} flex items-center justify-center border-[1.5px] border-base-100`}
            title={meta.label}
        >
            <Icon className={`${iconClass} text-white`} />
        </div>
    )
}
